export const SUP_WHATMAN_FILTER_SELECTOR_LOADER = {
  desktop: `
<div class="cui cui-grid cui-container">
  <div class="cui-row">
    <div class="cui-col-lg-7">
      <div class="cui-skeleton-paragraph -spacing--bottom-40">
        <div class="cui-skeleton-paragraph__content" style="width: 220px;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>

      <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-16">
        <div class="cui-skeleton-heading__content" style="width: 520px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>

      <div class="cui-skeleton-paragraph -spacing--bottom-40">
        <div class="cui-skeleton-paragraph__content" style="width: 640px;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="cui-row -spacing--bottom-64">
    <div class="cui-col-lg-6">
      <div class="cui-skeleton-heading -size--small -resolution--desktop -spacing--bottom-24">
        <div class="cui-skeleton-heading__content" style="width: 420px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>

      <div class="cui-skeleton__item -spacing--bottom-16" style="width: 100%; height: 56px;"></div>
      <div class="cui-skeleton__item -spacing--bottom-16" style="width: 100%; height: 56px;"></div>

      <div class="cui-skeleton-button -size--large" style="display: flex; justify-content: right; margin-top: 28px;">
        <div class="cui-skeleton-button__content" style="width: 130px;">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="cui-row" style="align-items: center; margin-bottom: 64px;">
    <div class="cui-col-lg-8 cui-col-md-8">
      <div class="cui-skeleton__item" style="width: 100%; height: 340px;"></div>
    </div>
    <div class="cui-col-lg-4 cui-col-md-4">
      <div class="cui-skeleton-heading -size--small -resolution--desktop -spacing--bottom-16" style="margin-top: 24px;">
        <div class="cui-skeleton-heading__content" style="width: 170px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -spacing--bottom-24">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-button -size--large">
        <div class="cui-skeleton-button__content" style="width: 180px;">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="cui-row" style="align-items: center; margin-bottom: 64px;">
    <div class="cui-col-lg-4 cui-col-md-4">
      <div class="cui-skeleton-heading -size--small -resolution--desktop -spacing--bottom-16">
        <div class="cui-skeleton-heading__content" style="width: 220px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-skeleton-paragraph -spacing--bottom-24">
        <div class="cui-skeleton-paragraph__content" style="width: 100%;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-button -size--large">
        <div class="cui-skeleton-button__content" style="width: 180px;">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    </div>
    <div class="cui-col-lg-8 cui-col-md-8">
      <div class="cui-skeleton__item" style="width: 100%; height: 340px;"></div>
    </div>
  </div>
</div>
`
};
